import Vue from "vue";
import VueRouter from "vue-router";
import HomeView from "../views/HomeView.vue";
import AboutView from "../views/AboutView.vue";
import TransportView from "../views/TransportView.vue";
import FarmingView from "../views/FarmingView.vue";
import SocialResponsibilityView from "../views/SocialResponsibilityView.vue";
import EnvironmentalResponsibilityView from "../views/EnvironmentalResponsibilityView.vue";
import Error404View from "../views/Error404View.vue";
import PolicyPrivacyView from "../views/PolicyPrivacyView.vue";
import WorkUsView from "../views/WorkUsView.vue";
import WorkUsResponseView from "../views/WorkUsResponseView.vue";
import ContactView from "../views/ContactView.vue";
import ContactResponseView from "../views/ContactResponseView.vue";
// import UnderConstructionView from "../views/UnderConstructionView.vue";

Vue.use(VueRouter);

const routes = [
  {
    name: "Início",
    path: "/",
    component: HomeView,
  },
  {
    name: "Sobre",
    path: "/sobre",
    component: AboutView,
  },
  {
    name: "Transportes",
    path: "/transportes",
    component: TransportView,
  },
  {
    name: "Agro",
    path: "/agro",
    component: FarmingView,
  },
  {
    name: "Responsabiilidade Social",
    path: "/responsabilidade-social",
    component: SocialResponsibilityView,
  },
  {
    name: "Responsabiilidade Ambiental",
    path: "/responsabilidade-ambiental",
    component: EnvironmentalResponsibilityView,
  },
  {
    name: "Trabalhe Conosco",
    path: "/trabalhe-conosco",
    component: WorkUsView,
  },
  {
    name: "Obrigado!",
    path: "/trabalhe-conosco/obrigado",
    component: WorkUsResponseView,
  },
  {
    name: "Fale Conosco",
    path: "/fale-conosco",
    component: ContactView,
  },
  {
    name: "Obrigado!",
    path: "/fale-conosco/obrigado",
    component: ContactResponseView,
  },
  {
    name: "Política de Privacidade",
    path: "/politica-de-privacidade",
    component: PolicyPrivacyView,
  },
  {
    path: "/erro404",
    name: "Erro 404",
    component: Error404View,
  },
  {
    path: "*",
    name: "Erro 404",
    component: Error404View,
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  scrollBehavior: (to, from, savedPosition) => {
    if (to.hash) {
      return {
        selector: to.hash,
        behavior: "smooth",
      };
    } else if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
  routes,
});

export default router;
